import { connect } from 'react-redux';
import ImageSlider from 'components/ImageSlider';
import { startGoBack } from 'routes/reducer';
import { push } from 'react-router-redux';
import { propertySelector } from 'routes/DateSelection/selectors';
import { createStructuredSelector } from 'reselect';

const mapStateToProps = createStructuredSelector({
  property: propertySelector
});

function mapDispatchToProps(dispatch) {
  return {
    navigateBack: url => {
      dispatch(startGoBack());
      dispatch(
        push({
          pathname: url,
          state: {
            transitionDirection: 'back'
          }
        })
      );
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ImageSlider);
